import { absolutePath } from "./absolutePath";

interface Params {
  params?: Record<string, unknown>;
}

export const communityPaymentMethod = {
  index: ({ params = {} }: Params = {}) =>
    absolutePath("community_payment_methods", params),
  subscriptionDefaults: ({ params = {} }: Params = {}) =>
    absolutePath("community_payment_methods/subscription_defaults", params),
  create: ({ params = {} }: Params = {}) =>
    absolutePath("community_payment_methods", params),
  update: (uuid: string, { params = {} }: Params = {}) =>
    absolutePath(`community_payment_methods/${uuid}`, params),
  destroy: (uuid: string, { params = {} }: Params = {}) =>
    absolutePath(`community_payment_methods/${uuid}`, params),
  setSubscriptionPaymentMethod: (uuid: string, { params = {} }: Params = {}) =>
    absolutePath(
      `community_payment_methods/${uuid}/set_subscription_payment_method`,
      params,
    ),
  setupIntent: {
    create: ({ params = {} }: Params = {}) =>
      absolutePath("community_payment_methods/setup_intents", params),
  },
};
